import type { FaireProductEntity } from "../../entity_types/product";

export const p_7up9xk83c5: FaireProductEntity = {
  token: "p_7up9xk83c5",
  type: "product",
  name: "TURTLENECK SWEATER DRESS WITH CABLE DETAIL(23070278-CAMEL)",
  brandToken: "b_q83zsr8m4m",
  brandName: "MILIO MILANO",
  imageUrl:
    "https://cdn.faire.com/fastly/976cfab8dea652c8389cda0c47b774d7cd6649de425090b5749ad20582000c49.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3014921e5b025dfaf00f081f22727a12cd8291774c9afb437928594407927cfc.jpeg",
    "https://cdn.faire.com/fastly/05f2c1ecd32363ee046175909b0126dff46a51420b74424d42415178f640a628.jpeg",
  ],
  priceDollars: 300,
  description:
    "Turtleneck sweater dress with cable detail\n\nDesigned with a turtleneck and cable detail, this sweater dress is both stylish and practical.\n\n52% viscose 26% polyester 22% polyamide\n\nMade in Italy",
  tags: [],
  msrpDollars: 750,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:04.829Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
